angular
	.module 'App.Repository'

.factory 'ProductCategoryRepository', ['BaseRepository', (BaseRepository) ->
	class ProductCategoryRepository extends BaseRepository
		@resource = '/product_categories'
		@isRestricted = true

		findByQuery: (query = null) ->
			if _.isEmpty(query)
				query = @createQuery()

			if !query.isSorted()
				query.sortBy 'name', 'ASC'

			super query

		searchCategories: (name) ->
			query = @createQuery()
			query.criteria 'name', 'LIKE', name
			query.setPagination 0, @pageSize
			@findByQuery(query)

	return new ProductCategoryRepository
]
